<template>
  <v-main class="fondo-app">
    <v-container fill-height>
    <v-row align="center" justify="center">
      <v-card
        ref="tarjeta"
        width="400"
        class="py-6 px-10 text-center"
        elevation="4"
        style="margin-top: -20px; min-width: 300px"
        :disabled="bloquearFormulario"
      >
        <div class="logo-cliente-login" style="width: 100%;">
          <img :src="`${$global.ruta}/${$global.URLParams}.png`" style="max-height: 80px; max-width: 200px" />
        </div>
        <div class="mt-8 text-h6" style="color: #31708f">Recuperación de contraseña</div>
        <v-text-field
          style="margin-right: 20px; margin-left: 20px"
          v-model="contrasena"
          label="Nueva contraseña"
          type="password"
          :rules="[reglas.requerido, reglas.longitudMinima]"
          autofocus
          @keydown="confirmarContrasena = ''"
          @change="confirmarContrasena = ''"
          @keypress.enter="enfocarConfirmarContrasena"
        >
        </v-text-field>
        <v-text-field
          style="margin-right: 20px; margin-left: 20px"
          ref="confirmarContrasena"
          v-model="confirmarContrasena"
          label="Confirmar nueva contraseña"
          type="password"
          :rules="[reglas.contrasenasCoinciden]"
          :disabled="!permitirConfirmarContrasena"
          @keypress.enter="establecerContrasenaClick"
        >
        </v-text-field>
        <v-btn
          class="mt-4"
          block
          large
          color="primary"
          elevation="2"
          @click="establecerContrasenaClick"
          :disabled="!contrasenasCumplenLasReglas">
          Restablecer contraseña
        </v-btn>
      </v-card>
    </v-row>
    </v-container>
  </v-main>
</template>

<script>
import api from "@/api";
export default {

  data() {
    this.correoElectronico = null;
    this.tokenSeguridad = null;
    this.fhs = null;
    return {
      bloquearFormulario: false,
      contrasena: "",
      confirmarContrasena: "",
      reglas: {
         requerido: (valor) => ((valor || "").trim() != "") || "Requerido",
         longitudMinima: (valor) => (!valor) || ((valor || "").trim().length >= 6) || "Longitud mínima: 6 caracteres",
         contrasenasCoinciden: (valor) => (!valor) || (this.contrasena == this.confirmarContrasena) || "Las contraseñas no coinciden",
      }
    };
  },
  computed: {
    permitirConfirmarContrasena() {
      return (this.contrasena.trim().length >= 6);
    },
    contrasenasCumplenLasReglas() {
      return ((this.contrasena.trim().length >= 6) && (this.confirmarContrasena == this.contrasena));
    },
  },
  methods: {
    // cargamos los parametros de la URL
    cargarParametrosURL() {
      var url = window.location.search;
      var urlParametros = new URLSearchParams(url);

      this.tokenSeguridad = urlParametros.get ("tokenSeguridad");
      this.fhs = atob (urlParametros.get ("fhs")); // fecha/hora solicitud

      console.log(this.tokenSeguridad);
      console.log(this.fhs);
    },

    // establecemos la contraseña que indica el usuario
    establecerContrasenaClick() {
      if (!this.contrasenasCumplenLasReglas)
        return;

      this.bloquearFormulario = true;
      api.restablecerContrasena (this.tokenSeguridad, this.contrasena)
        .then (() => {
          this.$cuadroDeDialogo.mostrar (this.$t ('Contraseña restablecida'), this.$t ('La contraseña se ha restablecido correctamente.'), [this.$t ('Iniciar sesión')])
            .then (() => {
              this.$router.push({ path: '/' });
            });
        })
        .catch ((respuesta) => {
          this.$cuadroDeDialogo.mostrar (this.$t ('Restablecer contraseña'), this.$t ('Se ha producido un error al restablecer la contraseña.') + respuesta.response.statusText, [this.$t ('Cerrar')]);
        })
        .finally (() => {
          this.bloquearFormulario = false;
        });
    },
    enfocarConfirmarContrasena() {
      this.$refs.confirmarContrasena.focus();
    },
  },
  created() {
    this.cargarParametrosURL();

    if (!this.tokenSeguridad || !this.fhs)
      this.$router.push({ path: "/" });
  },
};
</script>

<style>
</style>